import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-recommended-products]',
};

class RecommendedProducts extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation, Scrollbar],
      lazy: true,
      lazyPreloadPrevNext: 2,
      slidesPerView: 1.6,
      spaceBetween: 6,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 40,
      },
      breakpoints: {
        640: {
          slidesPerView: 2.6,
          spaceBetween: 20,
        },
        744: {
          slidesPerView: 2.3,
          spaceBetween: 28,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 28,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 28,
        },
        1665: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('recommended-products', RecommendedProducts);
